<template>
  <Layout>
    <template #content>
      <div class="mainContent promotionMain">
        <pageHead device="desktop" page="activity" :title="Title" description=""/>
        <div class="container Container">
          <div class="promotion ">
            <h1 class="title"><span class="bg">{{ Title }}</span><q class="dn fg">{{ Title }}</q></h1>
            <div class="promotionBox">
              <div class="promotionTypeBox">
                <div class="promotionType">
                  <h2 class="typeTitle">優惠分類</h2>
                  <ul>
                    <li>
                      <b-button @click="ChangeTabId(0)" :class="{ active: tab_id == 0 }">
                        {{ $t('store.all_activity')}}
                      </b-button>
                    </li>
                    <li
                      v-for="(item, index) in ActivityTabList"
                    >
                      <b-button @click="ChangeTabId(item.id)" :class="{ active: tab_id == item.id }">
                        {{ item.name_pc }}<!-- name_mobile -->
                      </b-button>
                    </li>
                  </ul>
                </div>
              </div>

              <div role="tablist" class="promotionList">
                <div
                  class="discount accordion"
                  v-for="(item, index) in ActivityList"
                  :key="index"
                  v-show="ShowActivity(item.tab_id)"
                >
                  <!-- v-show="tab_id == 0 || item.tab_id.indexOf(tab_id) >= 0" -->
                  <b-card no-body class="mb-1" :id="`card-accordion-${item.activity_id}`">
                    <b-card-header header-tag="header" :class="'p-1' + (index == 0 ? ' new' : '')" role="tab">

                      <b-button block variant="link" href="#" v-b-toggle="`accordion-${item.activity_id}`">

                        <div class="activity-new"><i class="icon icon-new"></i></div>
                        <div class="activity-end">
                          <b>{{ doing_d }}<q>{{ doing_o }}</q>{{ doing_i }}<q>{{ doing_n }}</q>{{ doing_g }}</b>
                        </div>
                        <div class="activity-img">
                          <img v-if="$route.query.id == item.activity_id || index == 0" class="card-img-top" :src="item.pc_image" :alt="item.activity_title"/>
                          <img v-else v-lazy="item.pc_image" class="card-img-top" @load="onImageLoaded" :alt="item.activity_title"/>
                        </div>
                        <div class="card-group-title">
                          <h3>{{ item.activity_title }}</h3>
                          <span>{{ item.activity_subtitle }}</span>
                        </div>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      :id="`accordion-${item.activity_id}`"
                      accordion="my-accordion"
                      role="tabpanel"
                      :visible="$route.query.id == item.activity_id"
                      @shown="CollapseShown(index, `card-accordion-${item.activity_id}`)"
                    >
                      <b-card-body>
                        <!-- 參加按鈕 -->
                        <button class="btn yesido">
                          <i class="icon icon-plus"></i><span>{{ btnYes }}</span>
                        </button>
                        <!-- 活動時間 -->
                        <div v-if="item.activity_time" class="card-group">
                          <span class="badge badge-pill badge-title">{{ top_actTime }}</span>
                          <p>{{ item.activity_time }}</p>
                        </div>
                        <!-- 活動對象 -->
                        <div v-if="item.activity_object" class="card-group">
                          <span class="badge badge-pill badge-title">{{ top_actQualified }}</span>
                          <p>{{ item.activity_object }}</p>
                        </div>
                        <!-- 活動內容 -->
                        <div v-if="item.activity_content" class="card-group align-items-start flex-column">
                          <span class="badge badge-pill badge-title">{{ top_actWay }}</span>
                          <div v-html="item.activity_content" style="width: 100%;"></div>
                        </div>
                        <!-- 活動規則 -->
                        <div v-if="item.activity_rule" class="card-group align-items-start flex-column">
                          <span class="badge badge-pill badge-title">{{ top_actMethod }}</span>
                          <div v-html="item.activity_rule" style="width: 100%;"></div>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </template>
  </Layout>
</template>

<script>
const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
  import pageHead from "~/components/common/pageHead.vue";
  import { debounce } from "lodash";
  export default {
    middleware: ["activity"],
    components: {
      Layout,
      pageHead,
    },
    data() {
      return {
        first: true,
        timeTop: null,
        initScroll: (this.$route.query.id && this.$route.query.id != 0)?true:false,
        tab_id: 0,
        doing_d: this.$t("store.discount.doing_d"),
        doing_o: this.$t("store.discount.doing_o"),
        doing_i: this.$t("store.discount.doing_i"),
        doing_n: this.$t("store.discount.doing_n"),
        doing_g: this.$t("store.discount.doing_g"),
        btnYes: this.$t("store.discount.btnYes"),
        top_actTime: this.$t("store.discount.time"),
        top_actQualified: this.$t("store.discount.object"),
        top_actWay: this.$t("store.discount.content"),
        top_actMethod: this.$t("store.discount.rule")
      };
    },
    methods: {
      changeLang() {
        this.doing_d = this.$t("store.discount.doing_d");
        this.doing_o = this.$t("store.discount.doing_o");
        this.doing_i = this.$t("store.discount.doing_i");
        this.doing_n = this.$t("store.discount.doing_n");
        this.doing_g = this.$t("store.discount.doing_g");
        this.btnYes = this.$t("store.discount.btnYes");
        this.top_actTime = this.$t("store.discount.time");
        this.top_actQualified = this.$t("store.discount.object");
        this.top_actWay = this.$t("store.discount.content");
        this.top_actMethod = this.$t("store.discount.rule");
      },
      CollapseShown(index, id) {
        let offset = 0;
        if (index != 0) {
          let anchor = this.$el.querySelector(`#${id}`);
          if (anchor)
            offset = anchor.offsetTop - 20;
        }

        this.Backtop(offset || 0)
      },
      Backtop(offset) {
        if (this.GetScrollTop() == offset) {
          return;
        }
        this.SetScrollTop(offset);
      },
      GetScrollTop() {
        return document.documentElement.scrollTop || document.body.scrollTop;
      },
      SetScrollTop(offset) {
        document.body.scrollTop = offset;
        document.documentElement.scrollTop = offset;
      },
      ChangeTabId(id) {
        this.tab_id = id;
      },
      ShowActivity(TabId) {
        return this.tab_id == 0 || TabId.indexOf(this.tab_id) >= 0;
      },
      onImageLoaded() {
        if(this.initScroll) {
          let firstId   = 0
          let firsIndex = 0
          this.ActivityList.find((element, index) => {
            if (element.activity_id == this.$route.query.id) {
              firsIndex = index;
              firstId   = element.activity_id;
            }
          });
          
          this.CollapseShown(firsIndex, `card-accordion-${firstId}`);
        }
      },
      ...mapActions('activity', ['getActivityList', 'getActivityTabList']),
    },
    mounted: function () {
      this.getActivityTabList();
      this.changeLang();
      if(this.initScroll) {
        this.onImageLoaded();
      }
      window.addEventListener('scroll', debounce(() => {
        this.initScroll = false;
      }, 200));
    },
    watch: {
      "$i18n.locale" () {
        this.changeLang();
      },
    },
    computed: {
      Title() {
        return this.$t("store.activity") + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
      },
      ...mapState('activity', ['ActivityList', 'ActivityTabList']),
      ...mapGetters(['WebSeoName', 'ShowPageWebSeoName'])
    }
  };
</script>
